function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//---- Automatically generated, don't update this part ----
/**
 * Describes a DMP document metadata, retrieved during the TD3.1 transaction.
 */

export default class DmpDocumentMetadata {
  constructor(params) {
    _defineProperty(this, "authors", []);
    _defineProperty(this, "eventCodes", []);
    _defineProperty(this, "documentFormat", void 0);
    _defineProperty(this, "documentStatus", void 0);
    _defineProperty(this, "documentVisibility", void 0);
    _defineProperty(this, "handle", void 0);
    _defineProperty(this, "size", void 0);
    _defineProperty(this, "classCode", void 0);
    _defineProperty(this, "creationDate", void 0);
    _defineProperty(this, "confidentialities", void 0);
    _defineProperty(this, "creationTime", void 0);
    _defineProperty(this, "description", void 0);
    _defineProperty(this, "documentFormatCode", void 0);
    _defineProperty(this, "documentFormatDescription", void 0);
    _defineProperty(this, "format", void 0);
    _defineProperty(this, "formatDescription", void 0);
    _defineProperty(this, "hashSha1", void 0);
    _defineProperty(this, "healthCareFacilityTypeCode", void 0);
    _defineProperty(this, "mimeType", void 0);
    _defineProperty(this, "nextUUId", void 0);
    _defineProperty(this, "practiceSettingCode", void 0);
    _defineProperty(this, "previousUUId", void 0);
    _defineProperty(this, "serviceStartDate", void 0);
    _defineProperty(this, "serviceStopDate", void 0);
    _defineProperty(this, "status", void 0);
    _defineProperty(this, "submissionDate", void 0);
    _defineProperty(this, "submissionSetId", void 0);
    _defineProperty(this, "title", void 0);
    _defineProperty(this, "type", void 0);
    _defineProperty(this, "uniqueId", void 0);
    _defineProperty(this, "uuid", void 0);
    this.authors = params.authors || [];
    this.eventCodes = params.eventCodes || [];
    this.documentFormat = params.documentFormat;
    this.documentStatus = params.documentStatus;
    this.documentVisibility = params.documentVisibility;
    this.handle = params.handle;
    this.size = params.size;
    this.classCode = params.classCode;
    this.creationDate = params.creationDate;
    this.description = params.description;
    this.documentFormatCode = params.documentFormatCode;
    this.documentFormatDescription = params.documentFormatDescription;
    this.hashSha1 = params.hashSha1;
    this.healthCareFacilityTypeCode = params.healthCareFacilityTypeCode;
    this.nextUUId = params.nextUUId;
    this.practiceSettingCode = params.practiceSettingCode;
    this.previousUUId = params.previousUUId;
    this.serviceStartDate = params.serviceStartDate;
    this.serviceStopDate = params.serviceStopDate;
    this.submissionDate = params.submissionDate;
    this.submissionSetId = params.submissionSetId;
    this.title = params.title;
    this.type = params.type;
    this.uniqueId = params.uniqueId;
    this.uuid = params.uuid;
    this.confidentialities = params.confidentialities;
    this.creationTime = params.creationTime;
    this.format = params.format;
    this.formatDescription = params.formatDescription;
    this.mimeType = params.mimeType;
    this.status = params.status;
  }
  toJson() {
    return {
      authors: this.authors,
      eventCodes: this.eventCodes,
      documentFormat: this.documentFormat,
      documentStatus: this.documentStatus,
      documentVisibility: this.documentVisibility,
      handle: this.handle,
      size: this.size,
      classCode: this.classCode,
      creationDate: this.creationDate,
      description: this.description,
      documentFormatCode: this.documentFormatCode,
      documentFormatDescription: this.documentFormatDescription,
      hashSha1: this.hashSha1,
      healthCareFacilityTypeCode: this.healthCareFacilityTypeCode,
      nextUUId: this.nextUUId,
      practiceSettingCode: this.practiceSettingCode,
      previousUUId: this.previousUUId,
      serviceStartDate: this.serviceStartDate,
      serviceStopDate: this.serviceStopDate,
      submissionDate: this.submissionDate,
      submissionSetId: this.submissionSetId,
      title: this.title,
      type: this.type,
      uniqueId: this.uniqueId,
      uuid: this.uuid,
      confidentialities: this.confidentialities,
      creationTime: this.creationTime,
      format: this.format,
      formatDescription: this.formatDescription,
      mimeType: this.mimeType,
      status: this.status
    };
  }

  //---- End of generated code ----
}